// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"d0007d1c","207":"955e77ac","453":"06a671af","587":"9cdf7651"}[chunkId] + ".chunk.js";
};